import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Modal,
  Select,
  Input,
  message,
  BackTop,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_ams_alumniCounselor,
  req_downloadfile_ams_alumniCounselor,
  req_single_onCampusPerson,
  req_edit_ams_alumniCounselor,
} from "../../api";
import { usrRole } from "../../utils/dataUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
//import { formateDate } from '../../utils/dateUtil'
import { getGraduateAcademicYear } from "../../utils/dateUtil";
import CounselorChangeModal from "./counselor-change-modal";

class SurveyCounselorList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    loading: false,
    domnloadFile: "",
    isShowInfoModal: false,
    //responseYearSurveyCode: '',

    /*特定參數*/
    searchFieldExtA: getGraduateAcademicYear(new Date()) - 1,
    searchFieldExtB: "NONE",
    searchFieldExtC: "NONE",
    searchFieldExtD: "NONE",
    searchFieldExtE: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_ams_alumniCounselor(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_ams_alumniCounselor(item, token);
    if (result.status === "success") {
      // 1 結果提示
      message.success("編輯成功");
      this.form_modify.current.resetFields();
      this.setState({ isShowInfoModal: false });
      // 2 更新列表
      this.api_page_items(this.current);
    } else {
      console.log(result);
    }
  };

  api_find_single_item = async (code) => {
    const { token } = this.props.user;
    const result = await req_single_onCampusPerson(code, token);
    //console.log(result)
    if (result) {
      return result.TwName;
    } else {
      // 查無此人
      return null;
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const { token, userCode } = this.props.user;
    // download file data
    const fileUrl = await req_downloadfile_ams_alumniCounselor(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE
    );
    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "查訪人員清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "YearGrade",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "部別",
        dataIndex: "Division",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        width: 80,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "原班導",
        dataIndex: "ClassTeacherName",
        width: 50,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "人數",
        dataIndex: "StudentsTotal",
        width: 50,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "輔訪員",
        dataIndex: "CounselorName",
        width: 50,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 70,
        render: (item) => {
          return (
            <>
              <Button
                type="primary"
                size="small"
                onClick={() => this.handle_show_ui_counselor(item)}
              >
                <i className="fas fa-user-cog"></i>
                <span style={{ marginLeft: "4px" }}> 變更</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NowStatusSecondary":
        switch (param) {
          case "尚待確認":
            return "red";
          case "就業":
          case "服役":
          case "升學":
          case "留學":
            return "green";
          case "其他":
            return "purple";
          default:
            return "default";
        }
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    //console.log(filters)
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_counselor = (item) => {
    // console.log(item)
    this.setState({ isShowInfoModal: true, item });
  };

  handle_modify_counselor = () => {
    this.form_modify.current
      .validateFields()
      .then((values) => {
        const { GraduateYear, ClassGradeCode, CounselorCode } = values;
        // console.log(data)
        // 檢核是否為(學校學生/教職員)人員

        this.api_find_single_item(CounselorCode).then((value) => {
          //if (value) {
          const item = {
            GraduateYear: GraduateYear,
            ClassGradeCode: ClassGradeCode,
            CounselorCode: CounselorCode,
            CounselorName: value ? value : "電訪員",
            condition: "COUNSELOR",
          };
          switch (CounselorCode) {
            case "GQM0001":
              item.CounselorName = "電訪員001";
              break;
            case "GQM0002":
              item.CounselorName = "電訪員002";
              break;
            case "GQM0003":
              item.CounselorName = "電訪員003";
              break;
            case "GQM0004":
              item.CounselorName = "電訪員004";
              break;
            case "GQM0005":
              item.CounselorName = "電訪員005";
              break;
            case "GQM0006":
              item.CounselorName = "電訪員006";
              break;
            case "GQM0007":
              item.CounselorName = "電訪員007";
              break;
            case "GQM0008":
              item.CounselorName = "電訪員008";
              break;
            case "GQM0009":
              item.CounselorName = "電訪員009";
              break;
            case "GQM0010":
              item.CounselorName = "電訪員010";
              break;
            default:
          }
          // console.log(item)
          this.api_modify_item(item);
          // message.info('此人本校教職員生')
          //} else {
          //    message.error('此人非本校教職員生，無法進行異動')
          //}
        });
      })
      .catch((error) => {
        //console.log(error.errorFields);
      });
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      deviceWidth,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowInfoModal,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="畢業學年度"
          style={{ width: 80, margin: "0 5px", backgroundColor: "lightyellow" }}
          value={searchFieldExtA}
          onChange={(event) =>
            this.setState({ searchFieldExtA: event.target.value })
          }
        />
        {deviceWidth > 1200 ? (
          <>
            <Select
              value={searchFieldExtC}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtC: value })}
            >
              <Select.Option value="NONE">部別</Select.Option>
              <Select.Option value="日間部">日間部</Select.Option>
              <Select.Option value="進修部">進修部</Select.Option>
              <Select.Option value="在職專班">在職專班</Select.Option>
              <Select.Option value="假日專班">假日專班</Select.Option>
            </Select>
            <Select
              value={searchFieldExtB}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtB: value })}
            >
              <Select.Option value="NONE">學制</Select.Option>
              <Select.Option value="四技">四技</Select.Option>
              <Select.Option value="二技">二技</Select.Option>
              <Select.Option value="七技">七技</Select.Option>
              <Select.Option value="研究所">研究所</Select.Option>
              <Select.Option value="二專">二專</Select.Option>
              <Select.Option value="三專">三專</Select.Option>
              <Select.Option value="五專">五專</Select.Option>
            </Select>
            <Select
              value={searchFieldExtD}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtD: value })}
            >
              <Select.Option value="NONE">學院</Select.Option>
              <Select.Option value="生活科技學院">生活科技學院</Select.Option>
              <Select.Option value="旅遊學院">旅遊學院</Select.Option>
              <Select.Option value="藝術學院">藝術學院</Select.Option>
              <Select.Option value="管理學院 ">管理學院</Select.Option>
              <Select.Option value="設計學院 ">設計學院</Select.Option>
            </Select>
            <Input
              placeholder="科系"
              style={{ width: 150, margin: "0 5px" }}
              value={searchFieldExtE}
              onChange={(event) =>
                this.setState({ searchFieldExtE: event.target.value })
              }
            />
          </>
        ) : (
          ""
        )}
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索其他條件</Select.Option>
          <Select.Option value="CounselorCode">輔訪員學(職)號</Select.Option>
          <Select.Option value="CounselorName">輔訪員姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>下載</span>
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />

        <Modal
          destroyOnClose={true}
          title="異動輔訪人員"
          visible={isShowInfoModal}
          width={500}
          onOk={this.handle_modify_counselor}
          onCancel={() => {
            this.form_modify.current.resetFields();
            this.setState({ isShowInfoModal: false });
          }}
        >
          <CounselorChangeModal
            setForm={(fm) => (this.form_modify = fm)}
            counselor={item}
          />
        </Modal>

        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SurveyCounselorList);
